export enum EnvirotainerContainerStatus {
	ALLOCATED,
	RELEASED,
	RETURNED,
}

export const envirotainerContainerStatusMap: Map<EnvirotainerContainerStatus, string> = new Map<EnvirotainerContainerStatus, string>([
	[EnvirotainerContainerStatus.ALLOCATED, "Allocated"],
	[EnvirotainerContainerStatus.RELEASED, "Released"],
	[EnvirotainerContainerStatus.RETURNED, "Returned"],
]);

export const envirotainerContainerStatusOptions = Object.keys(EnvirotainerContainerStatus)
	.map(key => ({
		value: [EnvirotainerContainerStatus[key] as EnvirotainerContainerStatus, "Device"],
		label: envirotainerContainerStatusMap.get(EnvirotainerContainerStatus[key] as EnvirotainerContainerStatus),
	}))
	.filter(option => option.label);
